// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import { IInvoiceItem, IInvoiceData } from "../Interfaces/IInvoice";
// import { editInvoice } from "../Services/InvoicePageService";
// import "../Style/EditInvoice.css";
// import Footer from "../Footer/Footer";
// import Swal from "sweetalert2";
// import { getStateCode } from "../Services/CommonService";
// import { getOrganizationDetails } from "../Services/orgService";
// import { getItems } from "../Services/inventoryService";
// import Select, { SingleValue } from "react-select";
// import { Container, Box } from "@mui/material";
// const EditInvoice: React.FC = () => {
//   const orgId = localStorage.getItem("orgId") ?? "";
//   const [items, setItems] = useState<
//     {
//       value: string;
//       label: string;
//       price: number;
//       discount: number;
//       tax: number;
//       hsn: string;
//       quantity: number;
//     }[]
//   >([]);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const invoice = location.state?.invoice || {};
//   const [errors, setErrors] = useState<{ [key: string]: string }>({});
//   const [orgDetails, setOrgDetails] = useState<any>(null);

//   const [formData, setFormData] = useState<IInvoiceData>({
//     orgId: invoice.orgId || "",
//     invoiceId: invoice.invoiceId || "",
//     customerId: invoice.customerId || "",
//     orderId: invoice.orderId || "",
//     orderDate: invoice?.orderDate || "",
//     salesPersonId: invoice.salesPersonId || "",
//     invoiceDate: invoice.invoiceDate ? invoice.invoiceDate.split("T")[0] : "",
//     dueDate: invoice.dueDate ? invoice.dueDate.split("T")[0] : "",
//     salesPersonName: invoice.salesPersonName || "",
//     customerName: invoice.customerName || "",
//     terms: invoice.terms || "Due on receipt",
//     totalTax: invoice.totalTax || 0,
//     buyerStateCode: invoice?.gstDetails?.[0]?.buyerStateCode ?? "",
//     //sellerStateCode: invoice?.gstDetails?.[0]?.sellerStateCode ?? "",
//     sellerStateCode:
//       invoice?.gstDetails && invoice?.gstDetails[0]
//         ? invoice?.gstDetails[0]?.sellerStateCode
//         : getStateCode(orgDetails?.state) || "",
//     isIntraState:
//       invoice?.gstDetails && invoice?.gstDetails[0]
//         ? invoice?.gstDetails?.[0]?.buyerStateCode ===
//           invoice?.gstDetails?.[0]?.sellerStateCode
//         : false,
//     totalCGST:
//       invoice?.gstDetails && invoice?.gstDetails[0]
//         ? invoice?.gstDetails[0]?.cgst
//         : 0,
//     totalSGST:
//       invoice?.gstDetails && invoice?.gstDetails[0]
//         ? invoice?.gstDetails[0]?.sgst
//         : 0,
//     buyerGST:
//       invoice?.gstDetails && invoice?.gstDetails[0]
//         ? invoice?.gstDetails[0]?.buyerGST
//         : "",
//     sellerGST:
//       invoice?.gstDetails && invoice?.gstDetails[0]
//         ? invoice?.gstDetails[0]?.sellerGST
//         : orgDetails?.GST,
//     totalDiscount: invoice.totalDiscount || 0,
//     subTotalAmount: invoice.subTotalAmount || 0,
//     shippingCharge: invoice.shippingCharge || 0,
//     grandTotal: invoice.grandTotal || 0,
//     status: invoice.status || "",
//     invoiceType: invoice.invoiceType || "",
//     createdBy: invoice.createdBy || "",
//     createdIp: invoice.createdIp || "",
//     itemDetails: invoice.items || [],
//     paymentMode: invoice?.paymentMode || "",
//   });

//   const includeShipping = formData.shippingCharge > 0 ? true : false;

//   const [shippingCharge, setShippingCharge] = useState<number>(
//     formData.shippingCharge
//   );
//   const loadItems = async () => {
//     try {
//       const itemData = await getItems(orgId);
//       const formattedItems = itemData.map((item: any) => ({
//         value: item.itemId,
//         label: `${item.name} ${item.desc || ""}`,
//         price: item.sellingPrice,
//         discount: 0,
//         tax: 0,
//         hsn: item.hsn,
//         quantity: item.quantity,
//       }));
//       setItems(formattedItems);
//       //setItemsKey((prev) => prev + 1); // ✅ Change key to force re-render
//     } catch (error) {
//       console.error("Error loading items:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Failed to load items",
//         text: "Please try again.",
//       });
//     }
//   };
//   useEffect(() => {
//     const loadOrganizationDetails = async () => {
//       try {
//         const orgData = await getOrganizationDetails(orgId);
//         setOrgDetails(orgData);
//       } catch (error) {
//         console.error(
//           "Failed to fetch Org details at invoice creation page",
//           error
//         );
//       }
//     };
//     loadOrganizationDetails();
//     loadItems();
//   }, []);

//   const validateForm = () => {
//     let newErrors: { [key: string]: string } = {};
//     if (formData.itemDetails?.length === 0)
//       newErrors[`items_name`] = "Please add at least one item to the invoice.";

//     formData.itemDetails?.forEach((item, index) => {
//       if (item.qty <= 0)
//         newErrors[
//           `item_qty_${index}`
//         ] = `${item.itemDesc}-Quantity must be greater than zero`;
//       if (item.price <= 0)
//         newErrors[
//           `item_price_${index}`
//         ] = `${item.itemDesc}-Rate must be greater than zero`;
//     });
//     if (Object.keys(newErrors).length > 0) {
//       Swal.fire({
//         icon: "error",
//         title: "Validation Error",
//         html: Object.values(newErrors).join("<br>"),
//       });
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
//   ) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleItemDetailsChange = (
//     index: number,
//     field: string,
//     value: string | number
//   ) => {
//     const updatedItems = [...formData.itemDetails];
//     updatedItems[index] = { ...updatedItems[index], [field]: value };
//     setFormData({ ...formData, itemDetails: updatedItems });
//   };
//   const handleAddNewItem = () => {
//     setFormData((prevData) => ({
//       ...prevData,
//       itemDetails: [
//         ...prevData.itemDetails,
//         {
//           itemId: "",
//           itemDesc: "",
//           qty: 1,
//           price: 0,
//           discount: 0,
//           Tax: 0,
//           amount: 0,
//           hsn: "",
//         },
//       ],
//     }));
//   };

//   const handleRemoveItem = (index: number) => {
//     const updatedItems = [...formData.itemDetails];
//     updatedItems.splice(index, 1);
//     setFormData({ ...formData, itemDetails: updatedItems });
//   };
//   // Calculate Subtotal
//   const subTotal = formData.itemDetails?.reduce(
//     (acc, item) => acc + item.qty * item.price,
//     0
//   );
//   //Calculate total Disc
//   const discTotal = formData.itemDetails?.reduce(
//     (acc, item) =>
//       acc +
//       (Number(item.qty) * Number(item.price) * Number(item.discount)) / 100,
//     0
//   );
//   const totalGST = formData.itemDetails?.reduce((acc, item) => {
//     const qty = Number(item.qty);
//     const rate = Number(item.price);
//     const discount = Number(item.discount);
//     const tax = Number(item.Tax);
//     const discountedAmount = qty * rate * (1 - discount / 100);
//     const gstAmount = (discountedAmount * tax) / 100;
//     return acc + gstAmount;
//   }, 0);

//   //Find the state code:
//   let totalCGST = 0;
//   let totalSGST = 0;
//   if (formData.buyerStateCode === formData?.sellerStateCode) {
//     totalCGST = totalGST / 2;
//     totalSGST = totalGST / 2;
//   }
//   // Calculate Total (Including GST and Shipping Charge)
//   const total =
//     formData.itemDetails?.reduce((acc, item) => {
//       const itemTotal =
//         item.qty *
//         item.price *
//         (1 - item.discount / 100) *
//         (1 + item.Tax / 100);
//       return acc + itemTotal;
//     }, 0) + shippingCharge; // Add Shipping Charge if enabled //+ (includeShipping ? shippingCharge : 0)

//   const invoiceData = {
//     orgId: formData.orgId,
//     invoiceId: formData.invoiceId,
//     customerId: formData.customerId,
//     orderId: formData.orderId,
//     orderDate: formData?.orderDate,
//     salesPersonId: formData.salesPersonId,
//     invoiceDate: new Date(formData.invoiceDate).toISOString(),
//     dueDate: new Date(formData.dueDate).toISOString(),
//     salesPersonName: formData.salesPersonName,
//     customerName: formData.customerName,
//     terms: formData.terms,
//     totalTax: totalGST,
//     totalDiscount: discTotal,
//     subTotalAmount: subTotal,
//     shippingCharge: shippingCharge,
//     grandTotal: total,
//     buyerStateCode: formData?.buyerStateCode,
//     sellerStateCode: formData?.sellerStateCode,
//     isIntraState: formData?.isIntraState,
//     totalCGST: totalCGST,
//     totalSGST: totalSGST,
//     buyerGST: formData?.buyerGST,
//     sellerGST: formData?.sellerGST,
//     paymentMode: formData?.paymentMode,
//     status: "due",
//     invoiceType: formData.invoiceType, //"Original",
//     createdBy: "AdminUser", // Replace with the current user
//     createdIp: "192.168.1.1", // Replace with actual IP address
//     itemDetails: formData.itemDetails.map((item, index) => ({
//       itemId: item.itemId,
//       itemDesc: item.itemDesc,
//       hsn: item.hsn,
//       qty: item.qty,
//       price: item.price,
//       discount: item.discount,
//       Tax: item.Tax,
//       amount: parseFloat(
//         (
//           item.qty *
//           item.price *
//           (1 - item.discount / 100) *
//           (1 + item.Tax / 100)
//         ).toFixed(2)
//       ),
//       taxType: "GST", // Replace with dynamic value if applicable
//     })),
//   };
//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       // Await the API call
//       const response = await editInvoice(invoiceData);
//       if (response?.message) {
//         Swal.fire({
//           icon: "success",
//           title: "Invoice Updated",
//           text: "Invoice updated successfully!",
//         }).then((result) => {
//           if (result.isConfirmed) {
//             navigate("/dashboard/sales/view-invoice");
//           }
//         });
//       } else {
//         console.error("Failed to update invoice:", response);
//       }
//     } catch (error) {
//       console.error("Error submitting invoice:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: error instanceof Error ? error.message : "An error occurred.",
//       });
//     }
//   };
//   const handleItemSelect = (index: number, selectedOption: any) => {
//     const updatedItems = [...formData.itemDetails];
//     updatedItems[index] = {
//       ...updatedItems[index],
//       itemDesc: selectedOption.label,
//       itemId: selectedOption.value,
//       price: selectedOption.price,
//       discount: selectedOption.discount,
//       Tax: selectedOption.tax,
//       hsn: selectedOption.hsn,
//     };
//     setFormData({ ...formData, itemDetails: updatedItems });
//   };
//   // Function to navigate back to the View Inventory page
//   const handleBackClick = () => {
//     navigate("/dashboard/sales/view-invoice");
//   };
//   return (
//     <>
//       <div className="page-location">
//         <span>Sales &gt; View Invoice &gt; Edit Invoice</span>
//       </div>
//       <button onClick={handleBackClick} className="back-button">
//         <i className="fas fa-arrow-left back-icon"></i>
//         Back
//       </button>
//       <Container maxWidth="lg" sx={{ padding: 1 }}>
//         <form onSubmit={handleSubmit}>
//           <form className="editInvoice-form">
//             <div className="form-group">
//               <label>Invoice ID:</label>
//               <input
//                 type="text"
//                 name="invoiceId"
//                 value={formData.invoiceId}
//                 onChange={handleChange}
//                 disabled
//               />
//             </div>
//             <div className="form-group">
//               <label>Customer Name:</label>
//               <input
//                 type="text"
//                 name="customerName"
//                 value={formData.customerName}
//                 onChange={handleChange}
//                 disabled
//               />
//             </div>
//             <div className="form-group">
//               <label>Invoice Date:</label>
//               <input
//                 type="date"
//                 name="invoiceDate"
//                 value={formData.invoiceDate}
//                 onChange={handleChange}
//                 disabled
//               />
//             </div>
//             <div className="form-group">
//               <label>Terms:</label>
//               <select
//                 name="terms"
//                 className="form-input"
//                 value={formData.terms}
//                 onChange={handleChange}
//               >
//                 <option value="Due on receipt">Due on receipt</option>
//                 <option value="Net 30">Net 30</option>
//               </select>
//             </div>
//             <div className="form-group">
//               <label>Due Date:</label>
//               <input
//                 type="date"
//                 name="dueDate"
//                 className="form-input"
//                 value={formData.dueDate}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="form-group">
//               <label>Buyer's Order No.:</label>
//               <input
//                 type="number"
//                 name="orderId"
//                 value={formData.orderId}
//                 className="form-input"
//                 min={0}
//                 step={1}
//                 onChange={(e) => {
//                   const value = Number(e.target.value);
//                   if (value < 0 || e.target.value.includes("-")) {
//                     Swal.fire({
//                       icon: "warning",
//                       title: "Invalid Order Number",
//                       text: "Order number should be greater than or equalto 0 and should not have (-) sign",
//                     }).then(() => {
//                       (e.target as HTMLInputElement).value = "0";
//                     });
//                   } else {
//                     handleChange(e);
//                   }
//                 }}
//                 onKeyDown={(e) => {
//                   if (e.key === "-") {
//                     e.preventDefault();
//                   }
//                 }}
//               />
//             </div>
//             <div className="form-group">
//               <label>Buyer's Order Date:</label>
//               <input
//                 type="date"
//                 name="orderDate"
//                 className="form-input"
//                 value={formData?.orderDate?.split("T")[0] || ""}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <label>Mode/Terms of Payment:</label>
//               <select
//                 name="paymentMode"
//                 className="form-input"
//                 value={formData.paymentMode}
//                 onChange={handleChange}
//               >
//                <option value="">Select Mode of Payment</option>
//               <option value="CASH">Cash</option>
//               <option value="CHEQUE">Cheque</option>
//               <option value="UPI">UPI</option>
//               <option value="BANK_TRANSFER">Bank Transfer</option>
//               <option value="NET_BANKING">Net Banking</option>
//               <option value="CREDIT">Credit</option>
//               </select>
//             </div>
//           </form>
//           {/* Add more fields here... */}
//           <div className="invoice-items-container">
//             <h2>Item Details</h2>
//             {formData.itemDetails?.map((item: IInvoiceItem, index: number) => (
//               <>
//                 <label
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "1.1rem",
//                     color: "#333",
//                     marginBottom: "5px",
//                     display: "block",
//                   }}
//                 >
//                   Item {index + 1}:
//                 </label>
//                 <div key={index} className="item-row">
//                   {/* <label>Item Name:</label>
//                   <input
//                     type="text"
//                     placeholder="Item Description"
//                     className="item-input"
//                     value={item.itemDesc}
//                     onChange={(e) =>
//                       handleItemDetailsChange(index, "itemDesc", e.target.value)
//                     }
//                   /> */}
//                   <label>
//                     Item Name<span style={{ color: "red" }}>*</span>:
//                     <Select
//                       className="input-hsn"
//                       //key={itemsKey} // ✅ Forces re-render
//                       options={items}
//                       value={items.find(
//                         (option) => option.value === item.itemId
//                       )}
//                       onChange={(selectedOption) =>
//                         handleItemSelect(index, selectedOption)
//                       }
//                       placeholder="Select Item"
//                       isSearchable
//                       styles={{
//                         container: (base: any) => ({
//                           ...base,
//                           width: "350px",
//                         }),
//                       }}
//                     />
//                   </label>
//                   <label>HSN:</label>
//                   <input
//                     type="text"
//                     placeholder="HSN"
//                     className="item-input"
//                     value={item.hsn}
//                     onChange={(e) => {
//                       handleItemDetailsChange(index, "hsn", e.target.value);
//                     }}
//                   />
//                   <label>Quantity:</label>
//                   <input
//                     type="number"
//                     placeholder="Quantity"
//                     className="item-input"
//                     value={item.qty}
//                     onChange={(e) => {
//                       const value = e.target.value;

//                       // Allow empty input while typing
//                       if (value === "") {
//                         handleItemDetailsChange(index, "qty", ""); // or null
//                         return;
//                       }

//                       const newQty = Number(value);

//                       if (!isNaN(newQty) && newQty > 0) {
//                         handleItemDetailsChange(index, "qty", newQty);
//                       } else {
//                         // Don’t show error here to avoid interrupting user typing
//                       }
//                     }}
//                     onBlur={(e) => {
//                       const value = e.target.value;
//                       const newQty = Number(value);
//                       if (value === "" || isNaN(newQty) || newQty <= 0) {
//                         Swal.fire({
//                           icon: "error",
//                           title: "Validation Error",
//                           text: "Quantity must be greater than zero",
//                         });
//                       }
//                     }}
//                   />
//                   <label>Rate:</label>
//                   <input
//                     type="number"
//                     placeholder="Rate"
//                     className="item-input"
//                     value={item.price}
//                     onChange={(e) => {
//                       const value = e.target.value;

//                       // Allow clearing input while typing
//                       if (value === "") {
//                         handleItemDetailsChange(index, "price", ""); // or null, based on your state
//                         return;
//                       }
//                       const newRate = Number(value);
//                       if (!isNaN(newRate) && newRate > 0) {
//                         handleItemDetailsChange(index, "price", newRate);
//                       } else {
//                         // Skip error here to avoid interrupting user typing
//                       }
//                     }}
//                     onBlur={(e) => {
//                       const value = e.target.value;
//                       const newRate = Number(value);
//                       if (value === "" || isNaN(newRate) || newRate <= 0) {
//                         Swal.fire({
//                           icon: "error",
//                           title: "Validation Error",
//                           text: "Rate must be greater than zero",
//                         });
//                       }
//                     }}
//                   />
//                 </div>
//                 <div key={index} className="item-row">
//                   <label>Discount:</label>
//                   <select
//                     className="item-input"
//                     value={item?.discount?.toString()}
//                     onChange={(e) =>
//                       handleItemDetailsChange(
//                         index,
//                         "discount",
//                         Number(e.target.value)
//                       )
//                     }
//                   >
//                     <option value="0">No Discount</option>
//                     <option value="5">5%</option>
//                     <option value="10">10%</option>
//                     <option value="15">15%</option>
//                     <option value="20">20%</option>
//                   </select>
//                   <label>Tax:</label>
//                   <select
//                     className="item-input"
//                     value={item.Tax}
//                     onChange={(e) =>
//                       handleItemDetailsChange(index, "Tax", e.target.value)
//                     }
//                   >
//                     <option value="0">Tax Not Applicable</option>
//                     <option value="3">3%</option>
//                     <option value="5">5%</option>
//                     <option value="12">12%</option>
//                     <option value="18">18%</option>
//                     <option value="28">28%</option>
//                   </select>
//                   <label>Total:</label>
//                   <input
//                     type="text"
//                     className="item-input"
//                     value={(
//                       item.qty *
//                       item.price *
//                       (1 - item.discount / 100) * // Apply discount
//                       (1 + item.Tax / 100)
//                     ) // Apply tax
//                       .toFixed(2)}
//                     readOnly
//                   />
//                   <img
//                     src="/icons8-delete-94.png"
//                     alt="Remove"
//                     className="remove-button"
//                     onClick={() => handleRemoveItem(index)}
//                   />
//                 </div>
//               </>
//             ))}
//             <button
//               type="button"
//               className="add-item-button"
//               onClick={handleAddNewItem}
//             >
//               + Add New Item
//             </button>
//             <div className="form-container">
//               <div className="form-group">
//                 <label>Sub Total:</label>
//                 <span className="form-output">{subTotal.toFixed(2)}</span>
//               </div>
//               {formData?.isIntraState ? (
//                 <>
//                   <div className="form-group">
//                     <label>CGST</label>
//                     <span className="form-output">{totalCGST?.toFixed(2)}</span>
//                   </div>
//                   <div className="form-group">
//                     <label>SGST</label>
//                     <span className="form-output">{totalSGST.toFixed(2)}</span>
//                   </div>
//                 </>
//               ) : (
//                 <div className="form-group">
//                   <label>IGST</label>
//                   <span className="form-output">{totalGST.toFixed(2)}</span>
//                 </div>
//               )}

//               <div className="form-group shipping-charge">
//                 <label className="shipping-label">Shipping Charge</label>
//                 {includeShipping && (
//                   <input
//                     type="number"
//                     className="shipping-input"
//                     placeholder="Enter Shipping Charge"
//                     value={shippingCharge}
//                     onChange={(e) => {
//                       const value = Number(e.target.value);
//                       if (value >= 0) {
//                         setShippingCharge(value);
//                       } else {
//                         Swal.fire({
//                           icon: "warning",
//                           title: "Invalid Shipping Charge",
//                           text: "Shipping charge must be greater than or equalto zero.",
//                         });
//                       }
//                     }}
//                   />
//                 )}
//               </div>

//               <div className="form-group">
//                 <label>Total:</label>
//                 <span className="form-output">{total.toFixed(2)}</span>
//               </div>
//             </div>
//           </div>
//           <button className="update-button" type="submit">
//             Save Changes
//           </button>
//         </form>
//       </Container>
//       <Box
//         sx={{
//           position: "relative",
//           left: 0,
//           bottom: 0,
//           width: "100%",
//           mt: 10,
//         }}
//       >
//         <Footer />
//       </Box>
//     </>
//   );
// };
// export default EditInvoice;

import React, { useEffect, useState, useRef, useMemo } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { IInvoiceItem, IInvoiceData } from "../Interfaces/IInvoice";
import { editInvoice, getInvoiceById } from "../Services/InvoicePageService";
import "../Style/EditInvoice.css";
import "../Style/ViewInvoiceDetails.css";
import "../Style/Common.css";
import Footer from "../Footer/Footer";
import Swal from "sweetalert2";
import { getStateCode, printViewInvoicePDF } from "../Services/CommonService";
import { getOrganizationDetails } from "../Services/orgService";
import { getItems } from "../Services/inventoryService";
import { getUsers } from "../Services/userService";
import {
  shareInvoicePdf,
  buildInvoiceWhatsAppMessage,
} from "../Services/shareInvoiceOnWhatsApp";
import {
  Container,
  Box,
  Grid,
  Paper,
  Typography,
  Divider,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Button,
  Chip,
  MenuItem,
  Autocomplete,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

// ─── Local types ──────────────────────────────────────────────────────────

interface ICustomerOption {
  id: string;
  name: string;
  email: string;
  phone: string;
  GSTIN: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  companyName: string;
}

interface IItemOption {
  value: string;
  label: string;
  price: number;
  discount: number;
  tax: number;
  hsn: string;
  quantity: number;
}

type TaxSlab = "3" | "5" | "12" | "18" | "28";

const DISCOUNT_OPTIONS = [0, 5, 10, 15, 20];
const TAX_OPTIONS = [0, 3, 5, 12, 18, 28];

const EditInvoice: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // ── orgId as state + short retry, so a hard refresh still populates the
  // page even if orgId hydrates into localStorage a beat after mount.
  const [orgId, setOrgId] = useState<string>(localStorage.getItem("orgId") ?? "");
  useEffect(() => {
    if (orgId) return;
    const interval = setInterval(() => {
      const stored = localStorage.getItem("orgId");
      if (stored) {
        setOrgId(stored);
        clearInterval(interval);
      }
    }, 200);
    const timeout = setTimeout(() => clearInterval(interval), 6000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [orgId]);

  const stateInvoice = location.state?.invoice || {};
  const rawInvoiceIdParam = searchParams.get("invoiceId");
  const invoiceId = rawInvoiceIdParam
    ? decodeURIComponent(rawInvoiceIdParam)
    : stateInvoice.invoiceId || "";

  const [loadingInvoice, setLoadingInvoice] = useState<boolean>(!!invoiceId);
  const [saving, setSaving] = useState(false);
  const [savedSuccessfully, setSavedSuccessfully] = useState(false);

  const [items, setItems] = useState<IItemOption[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [orgDetails, setOrgDetails] = useState<any>(null);
  const [customers, setCustomers] = useState<ICustomerOption[]>([]);

  const [formData, setFormData] = useState<IInvoiceData>({
    orgId: "",
    invoiceId: "",
    customerId: "",
    orderId: "",
    orderDate: "",
    salesPersonId: "",
    invoiceDate: "",
    dueDate: "",
    salesPersonName: "",
    customerName: "",
    terms: "Due on receipt",
    totalTax: 0,
    buyerStateCode: "",
    sellerStateCode: "",
    isIntraState: false,
    totalCGST: 0,
    totalSGST: 0,
    buyerGST: "",
    sellerGST: "",
    totalDiscount: 0,
    subTotalAmount: 0,
    shippingCharge: 0,
    grandTotal: 0,
    status: "",
    invoiceType: "",
    createdBy: "",
    createdIp: "",
    itemDetails: [],
    paymentMode: "",
    totalPaidAmount: 0,
    roundOff:0,
  } as IInvoiceData);

  const [shippingCharge, setShippingCharge] = useState<number>(0);
  const [roundOff, setRoundOff] = useState<number>(0);

  // ── Data loading ───────────────────────────────────────────────────────

  const loadItems = async () => {
    try {
      const itemData = await getItems(orgId);
      const formattedItems: IItemOption[] = itemData.map((item: any) => ({
        value: item.itemId,
        label: `${item.name} ${item.desc || ""}`,
        price: Number(item.sellingPrice) || 0,
        discount: 0,
        tax: 0,
        hsn: item.hsn,
        quantity: item.quantity,
      }));
      setItems(formattedItems);
    } catch (error) {
      console.error("Error loading items:", error);
      Swal.fire({ icon: "error", title: "Failed to load items", text: "Please try again." });
    }
  };

  const loadOrganizationDetails = async () => {
    try {
      const orgData = await getOrganizationDetails(orgId);
      setOrgDetails(orgData);
      return orgData;
    } catch (error) {
      console.error("Failed to fetch Org details at edit invoice page", error);
      return null;
    }
  };

  const loadCustomers = async () => {
    try {
      const customerData = await getUsers(orgId, "customer");
      const customersList: ICustomerOption[] = customerData.map((customer: any) => ({
        id: customer.Id,
        name:
          customer?.customerName ??
          (customer?.companyName ||
            [customer?.firstName, customer?.lastName].filter(Boolean).join(" ")),
        email: `${customer?.email ?? ""}`,
        GSTIN: `${customer?.GSTIN ?? ""}`,
        phone: `${customer?.phone ?? ""}`,
        street: `${customer?.address?.street ?? ""}`,
        city: `${customer?.address?.city ?? ""}`,
        state: `${customer?.address?.state ?? ""}`,
        zipCode: `${customer?.address?.zipCode ?? ""}`,
        country: `${customer?.address?.country ?? ""}`,
        companyName: `${customer?.companyName ?? ""}`,
      }));
      setCustomers(customersList);
      return customersList;
    } catch (error) {
      console.error("Failed to fetch customers at edit invoice page", error);
      return [];
    }
  };

  const fetchInvoice = async () => {
    if (!invoiceId || !orgId) {
      setLoadingInvoice(false);
      return;
    }
    setLoadingInvoice(true);
    try {
      const invoiceData = await getInvoiceById(invoiceId, orgId);
      setFormData((prev) => ({
        ...prev,
        ...invoiceData,
        invoiceDate: invoiceData.invoiceDate ? invoiceData.invoiceDate.split("T")[0] : "",
        dueDate: invoiceData.dueDate ? invoiceData.dueDate.split("T")[0] : "",
        orderDate: invoiceData?.orderDate || "",
        itemDetails: invoiceData.items || [],
        customerId: invoiceData.customerId || "",
        paymentMode: invoiceData?.paymentMode || "",
        totalPaidAmount: invoiceData?.totalPaidAmount || 0,
      }));
      setShippingCharge(Number(invoiceData?.shippingCharge) || 0);
      setRoundOff(Number(invoiceData?.roundOff) || 0);
    } catch (error) {
      console.error("Failed to fetch invoice for edit:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to load invoice",
        text: "Please go back and try again.",
      });
    } finally {
      setLoadingInvoice(false);
    }
  };

  useEffect(() => {
    if (!orgId) return;
    (async () => {
      await Promise.all([loadOrganizationDetails(), loadItems(), loadCustomers()]);
      await fetchInvoice();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId, invoiceId]);

  // ── Customer selection (Autocomplete) ─────────────────────────────────

  const selectedCustomerById = useMemo(
    () => customers.find((c) => c.id === formData.customerId) || null,
    [customers, formData.customerId]
  );

  const handleCustomerSelect = (customer: ICustomerOption | null) => {
    setFormData((prev) => ({
      ...prev,
      customerId: customer?.id || "",
      customerName: customer?.name || "",
    }));
  };

  const buyerStateCode =
    selectedCustomerById?.GSTIN?.substring(0, 2) || getStateCode(selectedCustomerById?.state) || "";
  const sellerStateCode =
    orgDetails?.GST?.substring(0, 2) || getStateCode(orgDetails?.address?.[0]?.state) || "";
  const isIntraState = !!buyerStateCode && buyerStateCode === sellerStateCode;

  // ── Validation ─────────────────────────────────────────────────────────

  const validateForm = () => {
    let newErrors: { [key: string]: string } = {};
    if (!formData.customerId) newErrors["customer"] = "Please select a customer.";
    if (formData.itemDetails?.length === 0)
      newErrors["items_name"] = "Please add at least one item to the invoice.";

    formData.itemDetails?.forEach((item, index) => {
      if (item.qty <= 0)
        newErrors[`item_qty_${index}`] = `${item.itemDesc}-Quantity must be greater than zero`;
      if (item.price <= 0)
        newErrors[`item_price_${index}`] = `${item.itemDesc}-Rate must be greater than zero`;
    });
    if (Object.keys(newErrors).length > 0) {
      Swal.fire({ icon: "error", title: "Validation Error", html: Object.values(newErrors).join("<br>") });
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ── CHANGE: retyped to match what MUI's TextField (text, date, AND
  // select variants) actually reports through onChange. The old signature
  // (`HTMLInputElement | HTMLSelectElement`) doesn't match TextField's own
  // declared prop type (`HTMLInputElement | HTMLTextAreaElement`), which is
  // exactly what TS2322 was complaining about on every date field.
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleItemDetailsChange = (index: number, field: string, value: string | number) => {
    const updatedItems = [...formData.itemDetails];
    updatedItems[index] = { ...updatedItems[index], [field]: value };
    setFormData({ ...formData, itemDetails: updatedItems });
  };

  const handleAddNewItem = () => {
    setFormData((prevData) => ({
      ...prevData,
      itemDetails: [
        ...prevData.itemDetails,
        { itemId: "", itemDesc: "", qty: 1, price: 0, discount: 0, Tax: 0, amount: 0, hsn: "" },
      ],
    }));
  };

  const handleRemoveItem = (index: number) => {
    const updatedItems = [...formData.itemDetails];
    updatedItems.splice(index, 1);
    setFormData({ ...formData, itemDetails: updatedItems });
  };

  const handleItemSelect = (index: number, selectedOption: IItemOption | null) => {
    if (!selectedOption) return;
    const updatedItems = [...formData.itemDetails];
    updatedItems[index] = {
      ...updatedItems[index],
      itemDesc: selectedOption.label,
      itemId: selectedOption.value,
      price: selectedOption.price,
      discount: selectedOption.discount,
      Tax: selectedOption.tax,
      hsn: selectedOption.hsn,
    };
    setFormData({ ...formData, itemDetails: updatedItems });
  };

  // ── Calculations ───────────────────────────────────────────────────────

  const subTotal = formData.itemDetails?.reduce((acc, item) => acc + item.qty * item.price, 0) || 0;

  const discTotal =
    formData.itemDetails?.reduce(
      (acc, item) => acc + (Number(item.qty) * Number(item.price) * Number(item.discount)) / 100,
      0
    ) || 0;

  const totalGST =
    formData.itemDetails?.reduce((acc, item) => {
      const qty = Number(item.qty);
      const rate = Number(item.price);
      const discount = Number(item.discount);
      const tax = Number(item.Tax);
      const discountedAmount = qty * rate * (1 - discount / 100);
      return acc + (discountedAmount * tax) / 100;
    }, 0) || 0;

  let totalCGST = 0;
  let totalSGST = 0;
  if (isIntraState) {
    totalCGST = totalGST / 2;
    totalSGST = totalGST / 2;
  }

  const calculatedTotal =
    (formData.itemDetails?.reduce((acc, item) => {
      const itemTotal = item.qty * item.price * (1 - item.discount / 100) * (1 + item.Tax / 100);
      return acc + itemTotal;
    }, 0) || 0) + shippingCharge;

       // Final Grand Total
    const total = Number(
    (calculatedTotal + Number(roundOff || 0)).toFixed(2)
    );

  const taxSummary: Record<TaxSlab, number> = { "3": 0, "5": 0, "12": 0, "18": 0, "28": 0 };
  formData.itemDetails.forEach((item) => {
    const qty = Number(item.qty);
    const rate = Number(item.price);
    const discount = Number(item.discount);
    const tax = Number(item.Tax);
    const discountedAmount = qty * rate * (1 - discount / 100);
    const gstAmount = (discountedAmount * tax) / 100;
    const taxKey = tax.toString() as TaxSlab;
    if (taxKey in taxSummary) taxSummary[taxKey] += gstAmount;
  });

  const buildInvoicePayload = () => ({
    orgId: formData.orgId || orgId,
    invoiceId: formData.invoiceId,
    customerId: formData.customerId,
    orderId: formData.orderId,
    orderDate: formData?.orderDate,
    salesPersonId: formData.salesPersonId,
    invoiceDate: new Date(formData.invoiceDate).toISOString(),
    dueDate: new Date(formData.dueDate).toISOString(),
    salesPersonName: formData.salesPersonName,
    customerName: formData.customerName,
    terms: formData.terms,
    totalTax: totalGST,
    totalDiscount: discTotal,
    subTotalAmount: subTotal,
    shippingCharge: shippingCharge,
    grandTotal: total,
    roundOff:roundOff,
    buyerStateCode,
    sellerStateCode,
    isIntraState,
    totalCGST,
    totalSGST,
    buyerGST: selectedCustomerById?.GSTIN || "",
    sellerGST: orgDetails?.GST || "",
    paymentMode: formData?.paymentMode,
    status: formData.status || "due",
    invoiceType: formData.invoiceType,
    createdBy: formData.createdBy || "AdminUser",
    createdIp: formData.createdIp || "192.168.1.1",
    itemDetails: formData.itemDetails.map((item) => ({
      itemId: item.itemId,
      itemDesc: item.itemDesc,
      hsn: item.hsn,
      qty: item.qty,
      price: item.price,
      discount: item.discount,
      Tax: item.Tax,
      amount: parseFloat(
        (item.qty * item.price * (1 - item.discount / 100) * (1 + item.Tax / 100)).toFixed(2)
      ),
      taxType: "GST",
    })),
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    const invoiceData = buildInvoicePayload();
    setSaving(true);
    try {
      const response = await editInvoice(invoiceData);
      if (response?.message) {
        setFormData((prev) => ({ ...prev, ...invoiceData } as IInvoiceData));
        setSavedSuccessfully(true);

        Swal.fire({
          icon: "success",
          title: "Invoice Updated",
          text: "Invoice updated successfully! You can now print, download, or share it.",
          showCancelButton: true,
          confirmButtonText: "Print / Share",
          cancelButtonText: "Back to List",
        }).then((result) => {
          if (result.isConfirmed) {
            setPreviewOpen(true);
          } else {
            navigate("/dashboard/sales/view-invoice");
          }
        });
      } else {
        console.error("Failed to update invoice:", response);
      }
    } catch (error) {
      console.error("Error submitting invoice:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error instanceof Error ? error.message : "An error occurred.",
      });
    } finally {
      setSaving(false);
    }
  };

  const handleBackClick = () => navigate("/dashboard/sales/view-invoice");

  // ── Print / Preview / Download / WhatsApp — unchanged ──────────────────
  const [previewOpen, setPreviewOpen] = useState(false);
  const [waPhone, setWaPhone] = useState("");
  const [waStatus, setWaStatus] = useState<string | null>(null);
  const [busy, setBusy] = useState<"" | "print" | "download" | "whatsapp">("");
  const previewRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedCustomerById?.phone) setWaPhone(selectedCustomerById.phone);
  }, [selectedCustomerById?.phone]);

  const guardPrintAction = () => {
    if (!savedSuccessfully) {
      Swal.fire({
        icon: "info",
        title: "Save first",
        text: "Please save your changes before printing, downloading, or sharing this invoice.",
      });
      return false;
    }
    return true;
  };

  const handlePrintClick = () => {
    if (!guardPrintAction()) return;
    setPreviewOpen(true);
  };

  const confirmPrint = async () => {
    setBusy("print");
    try {
      printViewInvoicePDF(orgDetails, formData, selectedCustomerById, taxSummary, "print");
    } catch (error: any) {
      alert(`Failed to print invoice: ${error.message}`);
    } finally {
      setBusy("");
    }
  };

  const confirmDownload = async () => {
    setBusy("download");
    try {
      printViewInvoicePDF(orgDetails, formData, selectedCustomerById, taxSummary, "download");
    } catch (error: any) {
      alert(`Failed to generate PDF: ${error.message}`);
    } finally {
      setBusy("");
    }
  };

  const confirmWhatsAppShare = async () => {
    if (!waPhone.trim()) {
      setWaStatus("Enter the customer's WhatsApp number first.");
      return;
    }
    setBusy("whatsapp");
    setWaStatus(null);
    try {
      const blob = printViewInvoicePDF(
        orgDetails,
        formData,
        selectedCustomerById,
        taxSummary,
        "blob"
      ) as Blob;
      const message = buildInvoiceWhatsAppMessage(formData.invoiceId, formData.customerName, total);
      const result = await shareInvoicePdf(
        blob,
        `${formData.invoiceId.replace(/\//g, "_")}.pdf`,
        waPhone,
        message
      );
      if (result.method === "web-share") {
        setWaStatus("Shared via WhatsApp ✅");
      } else if (result.method === "manual-attach") {
        setWaStatus("PDF downloaded and WhatsApp chat opened — drag the PDF into the chat to send it.");
      }
    } catch (error: any) {
      setWaStatus("Could not prepare the PDF for sharing.");
    } finally {
      setBusy("");
    }
  };

  // ── Render ─────────────────────────────────────────────────────────────

  const itemColumnHeaders = ["Item Name", "HSN", "Qty", "Rate", "Discount", "Tax", "Total", ""];

  return (
    <>
      <div className="page-location">
        <span>Sales &gt; View Invoice &gt; Edit Invoice</span>
      </div>
      <button onClick={handleBackClick} className="back-button">
        <i className="fas fa-arrow-left back-icon"></i>
        Back
      </button>

      <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 }, py: 1 }}>
        {loadingInvoice ? (
          <Box textAlign="center" py={6}>
            <Typography color="text.secondary">Loading invoice…</Typography>
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* ── Invoice header fields ─────────────────────────────── */}
            <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2.5 }, mb: 2, borderRadius: 2 }}>
              <Typography variant="subtitle1" fontWeight={700} mb={1.5}>
                Invoice Details
              </Typography>
              <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth size="small" label="Invoice ID" name="invoiceId"
                    value={formData.invoiceId} disabled
                  />
                </Grid>

                {/* ── CHANGE: MUI Autocomplete instead of react-select —
                    it's built on the same TextField, so it now sits on
                    exactly the same baseline/height/label position as
                    Invoice ID and Invoice Date next to it. ────────────── */}
                <Grid item xs={12} sm={6} md={4}>
                  <Autocomplete
                    size="small"
                    options={customers}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    value={selectedCustomerById}
                    onChange={(_, value) => handleCustomerSelect(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Customer *"
                        error={!!errors.customer}
                        helperText={errors.customer}
                      />
                    )}
                  />
                </Grid>

                {/* ── CHANGE (#4): Invoice Date is now editable. ────────── */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth size="small" type="date" label="Invoice Date" name="invoiceDate"
                    InputLabelProps={{ shrink: true }}
                    value={formData.invoiceDate} onChange={handleChange}
                  />
                </Grid>

                {/* ── CHANGE (#3): standard MUI Select (MenuItem-based)
                    instead of a native <select> — reliably shows the
                    selected label, unlike the native version. ─────────── */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth size="small" select label="Terms" name="terms"
                    value={formData.terms} onChange={handleChange}
                  >
                    <MenuItem value="Due on receipt">Due on receipt</MenuItem>
                    <MenuItem value="Net 30">Net 30</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth size="small" type="date" label="Due Date" name="dueDate"
                    InputLabelProps={{ shrink: true }}
                    value={formData.dueDate} onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth size="small" label="Buyer's Order No." name="orderId"
                    value={formData.orderId}
                    inputProps={{ min: 0, step: 1 }}
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      if (value < 0 || e.target.value.includes("-")) {
                        Swal.fire({
                          icon: "warning",
                          title: "Invalid Order Number",
                          text: "Order number should be greater than or equal to 0 and should not have (-) sign",
                        });
                      } else {
                        handleChange(e);
                      }
                    }}
                    onKeyDown={(e) => { if (e.key === "-") e.preventDefault(); }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth size="small" required type="date" label="Buyer's Order Date" name="orderDate"
                    InputLabelProps={{ shrink: true }}
                    value={formData?.orderDate?.split("T")[0] || ""}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth size="small" select label="Mode/Terms of Payment" name="paymentMode"
                    value={formData.paymentMode} onChange={handleChange}
                  >
                    <MenuItem value="">Select Mode of Payment</MenuItem>
                    <MenuItem value="CASH">Cash</MenuItem>
                    <MenuItem value="CHEQUE">Cheque</MenuItem>
                    <MenuItem value="UPI">UPI</MenuItem>
                    <MenuItem value="BANK_TRANSFER">Bank Transfer</MenuItem>
                    <MenuItem value="NET_BANKING">Net Banking</MenuItem>
                    <MenuItem value="CREDIT">Credit</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", alignItems: "center" }}>
                  <Chip
                    size="small"
                    label={isIntraState ? "Intra-state (CGST+SGST)" : "Inter-state (IGST)"}
                    color={isIntraState ? "success" : "info"}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </Paper>

            {/* ── Item details ───────────────────────────────────────── */}
            <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2.5 }, mb: 2, borderRadius: 2 }}>
              <Typography variant="subtitle1" fontWeight={700} mb={1.5}>
                Item Details
              </Typography>

              {isMobile ? (
                // ── Mobile: stacked cards ──────────────────────────────
                formData.itemDetails?.map((item: IInvoiceItem, index: number) => {
                  const itemTotal = (
                    item.qty * item.price * (1 - item.discount / 100) * (1 + item.Tax / 100)
                  ).toFixed(2);
                  return (
                    <Paper key={index} variant="outlined" sx={{ p: 1.5, mb: 2, borderRadius: 2 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                        <Typography fontWeight={700} color="text.secondary">Item {index + 1}</Typography>
                        <IconButton size="small" color="error" onClick={() => handleRemoveItem(index)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Stack>
                      <Stack spacing={1.5}>
                        <Autocomplete
                          size="small"
                          options={items}
                          getOptionLabel={(option) => option.label}
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                          value={items.find((o) => o.value === item.itemId) || null}
                          onChange={(_, value) => handleItemSelect(index, value)}
                          renderInput={(params) => <TextField {...params} label="Item Name *" />}
                        />
                        <Stack direction="row" spacing={1.5}>
                          <TextField
                            fullWidth size="small" label="HSN" value={item.hsn}
                            onChange={(e) => handleItemDetailsChange(index, "hsn", e.target.value)}
                          />
                          <TextField
                            fullWidth size="small" type="number" label="Qty" value={item.qty}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "") { handleItemDetailsChange(index, "qty", ""); return; }
                              const newQty = Number(value);
                              if (!isNaN(newQty) && newQty > 0) handleItemDetailsChange(index, "qty", newQty);
                            }}
                          />
                        </Stack>
                        <Stack direction="row" spacing={1.5}>
                          <TextField
                            fullWidth size="small" type="number" label="Rate" value={item.price}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "") { handleItemDetailsChange(index, "price", ""); return; }
                              const newRate = Number(value);
                              if (!isNaN(newRate) && newRate > 0) handleItemDetailsChange(index, "price", newRate);
                            }}
                          />
                          <TextField
                            fullWidth size="small" select label="Discount" value={item.discount}
                            onChange={(e) => handleItemDetailsChange(index, "discount", Number(e.target.value))}
                          >
                            {DISCOUNT_OPTIONS.map((d) => (
                              <MenuItem key={d} value={d}>{d === 0 ? "No Discount" : `${d}%`}</MenuItem>
                            ))}
                          </TextField>
                        </Stack>
                        <Stack direction="row" spacing={1.5}>
                          <TextField
                            fullWidth size="small" select label="Tax" value={item.Tax}
                            onChange={(e) => handleItemDetailsChange(index, "Tax", Number(e.target.value))}
                          >
                            {TAX_OPTIONS.map((t) => (
                              <MenuItem key={t} value={t}>{t === 0 ? "Tax Not Applicable" : `${t}%`}</MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            fullWidth size="small" label="Total" value={itemTotal}
                            InputProps={{ readOnly: true }}
                          />
                        </Stack>
                      </Stack>
                    </Paper>
                  );
                })
              ) : (
                // ── Desktop / tablet: aligned table ────────────────────
                <TableContainer sx={{ overflowX: "auto", mb: 2 }}>
                  <Table size="small" sx={{ minWidth: 900 }}>
                    <TableHead>
                      <TableRow sx={{ "& th": { bgcolor: "grey.100", fontWeight: 700, fontSize: 12 } }}>
                        {itemColumnHeaders.map((h) => (
                          <TableCell key={h}>{h}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData.itemDetails?.map((item: IInvoiceItem, index: number) => {
                        const itemTotal = (
                          item.qty * item.price * (1 - item.discount / 100) * (1 + item.Tax / 100)
                        ).toFixed(2);
                        return (
                          <TableRow key={index}>
                            <TableCell sx={{ minWidth: 240 }}>
                              <Autocomplete
                                size="small"
                                options={items}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                value={items.find((o) => o.value === item.itemId) || null}
                                onChange={(_, value) => handleItemSelect(index, value)}
                                renderInput={(params) => <TextField {...params} placeholder="Select Item" />}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: 100 }}>
                              <TextField
                                size="small" value={item.hsn}
                                onChange={(e) => handleItemDetailsChange(index, "hsn", e.target.value)}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: 110 }}>
                              <TextField
                                size="small" type="number" value={item.qty}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === "") { handleItemDetailsChange(index, "qty", ""); return; }
                                  const newQty = Number(value);
                                  if (!isNaN(newQty) && newQty > 0) handleItemDetailsChange(index, "qty", newQty);
                                }}
                                onBlur={(e) => {
                                  const value = e.target.value;
                                  const newQty = Number(value);
                                  if (value === "" || isNaN(newQty) || newQty <= 0) {
                                    Swal.fire({ icon: "error", title: "Validation Error", text: "Quantity must be greater than zero" });
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: 125 }}>
                              <TextField
                                size="small" type="number" value={item.price}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === "") { handleItemDetailsChange(index, "price", ""); return; }
                                  const newRate = Number(value);
                                  if (!isNaN(newRate) && newRate > 0) handleItemDetailsChange(index, "price", newRate);
                                }}
                                onBlur={(e) => {
                                  const value = e.target.value;
                                  const newRate = Number(value);
                                  if (value === "" || isNaN(newRate) || newRate <= 0) {
                                    Swal.fire({ icon: "error", title: "Validation Error", text: "Rate must be greater than zero" });
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: 110 }}>
                              <TextField
                                size="small" select value={item.discount}
                                onChange={(e) => handleItemDetailsChange(index, "discount", Number(e.target.value))}
                              >
                                {DISCOUNT_OPTIONS.map((d) => (
                                  <MenuItem key={d} value={d}>{d === 0 ? "No Discount" : `${d}%`}</MenuItem>
                                ))}
                              </TextField>
                            </TableCell>
                            <TableCell sx={{ minWidth: 130 }}>
                              <TextField
                                size="small" select value={item.Tax}
                                onChange={(e) => handleItemDetailsChange(index, "Tax", Number(e.target.value))}
                              >
                                {TAX_OPTIONS.map((t) => (
                                  <MenuItem key={t} value={t}>{t === 0 ? "Tax Not Applicable" : `${t}%`}</MenuItem>
                                ))}
                              </TextField>
                            </TableCell>
                            <TableCell sx={{ minWidth: 130 }}>
                              <TextField size="small" value={itemTotal} InputProps={{ readOnly: true }} />
                            </TableCell>
                            <TableCell sx={{ minWidth: 48 }}>
                              <IconButton size="small" color="error" onClick={() => handleRemoveItem(index)}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              <Button
                type="button" variant="outlined" startIcon={<AddIcon />}
                onClick={handleAddNewItem} fullWidth={isMobile}
              >
                Add New Item
              </Button>

              <Divider sx={{ my: 2 }} />

              {/* ── Totals ─────────────────────────────────────────── */}
              <Grid container spacing={2} justifyContent="flex-end">
                <Grid item xs={12} sm={6} md={4}>
                  <Stack spacing={1}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="body2">Sub Total:</Typography>
                      <Typography variant="body2" fontWeight={600}>{subTotal.toFixed(2)}</Typography>
                    </Stack>
                    {isIntraState ? (
                      <>
                        <Stack direction="row" justifyContent="space-between">
                          <Typography variant="body2">CGST:</Typography>
                          <Typography variant="body2">{totalCGST.toFixed(2)}</Typography>
                        </Stack>
                        <Stack direction="row" justifyContent="space-between">
                          <Typography variant="body2">SGST:</Typography>
                          <Typography variant="body2">{totalSGST.toFixed(2)}</Typography>
                        </Stack>
                      </>
                    ) : (
                      <Stack direction="row" justifyContent="space-between">
                        <Typography variant="body2">IGST:</Typography>
                        <Typography variant="body2">{totalGST.toFixed(2)}</Typography>
                      </Stack>
                    )}
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Typography variant="body2">Shipping Charge:</Typography>
                      <TextField
                        size="small" sx={{ width: 130 }} type="number"
                        value={shippingCharge}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          if (value >= 0) {
                            setShippingCharge(value);
                          } else {
                            Swal.fire({
                              icon: "warning",
                              title: "Invalid Shipping Charge",
                              text: "Shipping charge must be greater than or equal to zero.",
                            });
                          }
                        }}
                      />
                    </Stack>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Typography variant="body2">Round Off:</Typography>
                    <TextField size="small" sx={{ width: 130 }}
                      type="number"
                      value={roundOff}
                      onChange={(e) => {
                          const value = Number(e.target.value);
                            setRoundOff(value);
                        }}
                  />
                    </Stack>
                    <Divider />
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight={700}>Total:</Typography>
                      <Typography variant="subtitle1" fontWeight={700}>{total.toFixed(2)}</Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>

            {/* ── Action bar ─────────────────────────────────────────── */}
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="flex-end" mb={4}>
              <Button
                type="submit" variant="contained" startIcon={<SaveIcon />}
                disabled={saving} fullWidth={isMobile}
              >
                {saving ? "Saving…" : "Save Changes"}
              </Button>
              <Button
                type="button" variant="outlined" startIcon={<PrintIcon />}
                disabled={!savedSuccessfully} onClick={handlePrintClick} fullWidth={isMobile}
              >
                Print / Share
              </Button>
            </Stack>
          </form>
        )}
      </Container>

      {/* ── Preview → Print / Download / WhatsApp — identical to
           ViewInvoiceDetails ─────────────────────────────────────────── */}
      <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Invoice Preview
          <IconButton size="small" onClick={() => setPreviewOpen(false)}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box ref={previewRef}>
            <Typography variant="subtitle1" fontWeight={700}>{formData.invoiceId}</Typography>
            <Typography variant="body2">{formData.customerName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {formData.invoiceDate ? new Date(formData.invoiceDate).toLocaleDateString("en-GB") : "N/A"}
            </Typography>
            <Box mt={1}>
              <Typography variant="body2">Subtotal: {subTotal.toFixed(2)}</Typography>
              {isIntraState ? (
                <>
                  <Typography variant="body2">CGST: {totalCGST.toFixed(2)}</Typography>
                  <Typography variant="body2">SGST: {totalSGST.toFixed(2)}</Typography>
                </>
              ) : (
                <Typography variant="body2">IGST: {totalGST.toFixed(2)}</Typography>
              )}
              <Typography variant="subtitle2" fontWeight={700}>Grand Total: {total.toFixed(2)}</Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ flexDirection: "column", alignItems: "stretch", gap: 1, p: 2 }}>
          <Stack direction="row" spacing={1}>
            <TextField
              size="small" fullWidth label="Customer WhatsApp number"
              value={waPhone} onChange={(e) => setWaPhone(e.target.value)}
            />
            <Button variant="outlined" color="success" startIcon={<WhatsAppIcon />} disabled={busy !== ""} onClick={confirmWhatsAppShare}>
              {busy === "whatsapp" ? "Preparing…" : "Share"}
            </Button>
          </Stack>
          {waStatus && <Typography variant="caption" color="text.secondary">{waStatus}</Typography>}
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button onClick={() => setPreviewOpen(false)}>Close</Button>
            <Button variant="outlined" startIcon={<DownloadIcon />} disabled={busy !== ""} onClick={confirmDownload}>
              {busy === "download" ? "Generating…" : "Download PDF"}
            </Button>
            <Button variant="contained" startIcon={<PrintIcon />} disabled={busy !== ""} onClick={confirmPrint}>
              Print
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>

      <Box sx={{ width: "100%", mt: isMobile ? 4 : 6 }}>
        <Footer />
      </Box>
    </>
  );
};

export default EditInvoice;